// import throttle from "lodash.throttle";
// import debounce from "lodash.debounce";

colourSelectors();
function colourSelectors() {
  const selectors = document.querySelectorAll(".pdp-colour-selectors > a");
  const title = document.querySelector("[selectors-title]");

  if (!selectors) return;
  for (const selector of selectors) {
    selector.addEventListener(
      "pointerenter",
      () => (title.innerText = selector.dataset.title)
    );
    selector.addEventListener(
      "pointerleave",
      () => (title.innerText = title.dataset.title)
    );
  }
}

productAccordions();
function productAccordions() {
  const panels = document.querySelectorAll(".pdp-accordion .panel");
  const checkboxes = document.querySelectorAll("[accordions-outer] .checkbox");

  if (!panels) return;

  // Close other panels on opening one
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      checkboxes.forEach((c) => {
        if (c.id === checkbox.id) return;
        c.checked = false;
      });
    });
  });

  // Resize observers for panels
  const resizer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      entry.target.style.setProperty(
        "--height",
        entry.target.scrollHeight + "px"
      );
    }
  });

  for (const panel of panels) {
    panel.style.setProperty("--height", panel.scrollHeight + "px");
    resizer.observe(panel);
  }
}

productPairings();
function productPairings() {
  const els = document.querySelectorAll(".pdp-accordion-pairings");
  if (!els) return;
  els.forEach((el) => setObservableHeight(el));
}

// atcQuickView();
// function atcQuickView() {
//   const bar = document.querySelector(".pdp-atc-quickview");
//   if (!bar) return;

//   // El and pos
//   const atc = document.querySelector(".pdp-atc");
//   const footer = document.querySelector("#shopify-section-footer");

//   if (!atc || !footer) return;

//   let atcPos = atc.getBoundingClientRect().top;
//   let footerPos = footer.getBoundingClientRect().top;

//   // Resizer
//   window.onresize = throttle(() => {
//     atcPos = atc.getBoundingClientRect().top;
//     footerPos = footer.getBoundingClientRect().top;
//   }, 200);

//   // Scroller
//   window.onscroll = throttle(() => {
//     if (window.scrollY > atcPos && window.scrollY < footerPos) {
//       bar.classList.add("active");
//     } else {
//       bar.classList.remove("active");
//     }
//   }, 200);
// }

pdpImageGallery();
function pdpImageGallery() {
  // Get el and guard
  const gallery = document.querySelector(".pdp-gallery");
  const thumbsTrack = document.querySelector(".pdp-gallery-thumbs");
  if (!gallery && !thumbsTrack) return;

  // Draggability
  dragging();
  function dragging() {
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
      pos = {
        left: gallery.scrollLeft,
        top: gallery.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      // console.log(pos);

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      // Scroll the element
      gallery.scrollTop = pos.top - dy;
      gallery.scrollLeft = pos.left - dx;

      // console.log(pos.top - dy, pos.left - dx);

      // Change the cursor and prevent user from selecting the text
      gallery.style.cursor = "grabbing";
      gallery.style.userSelect = "none";
      // gallery.style.scrollSnapType = "none";
      // gallery.style.scrollBehavior = "initial";
    };

    const mouseUpHandler = function () {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);

      // gallery.style.removeProperty("scroll-behavior");
      // gallery.style.removeProperty("scroll-snap-type");
      gallery.style.cursor = "grab";
      gallery.style.removeProperty("user-select");
    };

    gallery.addEventListener("mousedown", mouseDownHandler);
  }

  // Get thumbs
  const thumbs = thumbsTrack.querySelectorAll(".thumb");
  const thumbsInner = thumbsTrack.firstElementChild;

  // Run scroll function
  gallery.onscroll = debounce(() => {
    const slideWidth = gallery.firstElementChild.scrollWidth;
    const activeIndex = Math.round(gallery.scrollLeft / slideWidth);

    // Thumbs
    thumbs.forEach((t) => t.classList.remove("active"));
    const thumb = thumbs[activeIndex];
    thumb.classList.add("active");

    // Scroll thumb track
    thumbsInner.scrollTo({
      left: thumb.getBoundingClientRect().left - 20,
      behaviour: "smooth",
    });
  }, 100);

  // Thumb navigation
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      gallery.scrollTo({
        left: gallery.firstElementChild.scrollWidth * index,
        behavior: "smooth",
      });
    });
  });
}
